var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnblock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1609_4896)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.5 15.2381C11.6687 15.2381 12.625 14.381 12.625 13.3333C12.625 12.2857 11.6687 11.4286 10.5 11.4286C9.33125 11.4286 8.375 12.2857 8.375 13.3333C8.375 14.381 9.33125 15.2381 10.5 15.2381ZM16.875 6.66667H15.8125V4.7619C15.8125 2.13333 13.4325 0 10.5 0C7.5675 0 5.1875 2.13333 5.1875 4.7619H7.20625C7.20625 3.13333 8.68313 1.80952 10.5 1.80952C12.3169 1.80952 13.7938 3.13333 13.7938 4.7619V6.66667H4.125C2.95625 6.66667 2 7.52381 2 8.57143V18.0952C2 19.1429 2.95625 20 4.125 20H16.875C18.0438 20 19 19.1429 19 18.0952V8.57143C19 7.52381 18.0438 6.66667 16.875 6.66667ZM16.875 18.0952H4.125V8.57143H16.875V18.0952Z",
    fill: "#223CDD"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1609_4896"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnblock);
export default __webpack_public_path__ + "static/media/unblock.399cb233fed291b6485df1867a7e8432.svg";
export { ForwardRef as ReactComponent };